import {
  IonCardContent,
  IonCol,
  IonGrid,
  IonRow
} from "@ionic/react";
import React, { useEffect } from "react";

import AnnouncementBanner from "../components/AnnouncementBanner";
import Content from "../components/Content";
import PleaseLoginCard from "../components/PleaseLoginCard";
import RequestAccessCard from "../components/RequestAccessCard";
import SongList from "../components/SongList";
import { useConfig } from "../data/store/useConfig";
import { useProfile } from "../data/store/useProfile";
import { useSongs } from "../data/store/useSongs";
import { ENABLE_GROUPS } from "../config/env";
import isEmpty from "lodash.isempty";
import CompactSongList from "../components/CompactSongList";
import { CompactToggle } from "../components/CompactToggle";
import "../components/styles.scss";
import { usePageTitle } from "../util/sugar";


const UnfilteredSongsPage: React.FC = () => {
  const { authorId, status: userStatus,compact } = useProfile();
  const {
    fetchSome,
    status,
    initialFetchStatus,
    timeline,
  } = useSongs();
  const { isAlumni, activeMemberships } = useConfig();



  const membership = activeMemberships();
  const unauthenticated = userStatus === "unauthenticated";
  const authenticated = userStatus === "authenticated";
  // When groups are disabled, always show status; otherwise only when user has membership
  const songStatus = !ENABLE_GROUPS || !isEmpty(membership) ? status : "idle";

  usePageTitle("Songs");


  const handleFetchMore = () => {
       fetchSome(membership);
  };


  useEffect(() => {
    // When groups are disabled, fetch songs regardless of membership
    // When groups are enabled, only fetch if user has membership
    const shouldFetch = ENABLE_GROUPS ? !isEmpty(membership) : true;

    if (authenticated && initialFetchStatus === "initial" && shouldFetch) {
      fetchSome(membership);
    }
  }, [authenticated, initialFetchStatus, membership, fetchSome]);

  if (ENABLE_GROUPS && isAlumni() === false) {
    return (
      <Content>
        <RequestAccessCard authorId={authorId} />
      </Content>
    );
  } else if (unauthenticated) {
    return (
      <Content>
        <PleaseLoginCard action="View Songs" />
      </Content>
    );
  }

  return (
    <Content>
      <IonGrid style={{margin:0,padding:0}}>
        <IonRow>
          <IonCol style={{padding:0,margin:0}} sizeMd="8" sizeLg="6" offsetMd="2" offsetLg="3">
            <AnnouncementBanner />
            <IonCardContent
              style={{
                padding: "0px",
                borderRadius: "8px",
                margin: "0 16px",
              }}
            >
            <CompactToggle/>
            </IonCardContent>

            {ENABLE_GROUPS && isEmpty(membership) && (
              <RequestAccessCard message="You have no active classes" />
            )}

            {compact ? (
              <CompactSongList
                songRefs={timeline}
                fetchMore={handleFetchMore}
                status={songStatus}
              />
            ) : (
              <SongList
                status={songStatus}
                fetchMore={handleFetchMore}
                songRefs={timeline}
              />
            )}
          </IonCol>
        </IonRow>
      </IonGrid>
    </Content>
  );
};

export default UnfilteredSongsPage;
